import { render, staticRenderFns } from "./form-classe-toxicologica.vue?vue&type=template&id=c308fcb4&"
import script from "./form-classe-toxicologica.vue?vue&type=script&lang=js&"
export * from "./form-classe-toxicologica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports